import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import JobList from '../JobsList/JobList';
import usePageTitle from '../../hooks/usePageTitle';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(4),
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(3, 2)
    }
  },
  header: {
    marginBottom: theme.spacing(3)
  },
  title: {
    fontWeight: 700,
    marginBottom: theme.spacing(1)
  },
  subtitle: {
    color: theme.palette.text.secondary
  }
}));

const JobsSearch = () => {
  const classes = useStyles();
  usePageTitle('Search Jobs');

  return (
    <Box className={classes.root}>
      <div className={classes.header}>
        <Typography variant="h4" className={classes.title}>
          Search Jobs
        </Typography>
        <Typography variant="body2" className={classes.subtitle}>
          Filter by category and role type to find the best match.
        </Typography>
      </div>
      <JobList showFilters showCarousel={false} />
    </Box>
  );
};

export default JobsSearch;
